import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "drawer-content blog-form" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_8 = ["textContent"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Cancel", -1)
const _hoisted_10 = [
  _hoisted_9
]

import { computed, onMounted, reactive, watch } from "vue";
import { useStore } from "vuex";
import useVuelidate from "@vuelidate/core";
import { Actions } from "@/store";
import { Blog, blogValidations } from "@/models/blog";
import Loading from "@/components/common/Loading.vue";
import Field from "@/components/common/Field.vue";
import { useLoading } from "../common/loading.composable";
import FieldMarkdown from "../common/FieldMarkdown.vue";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogForm',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const blog = reactive<Blog>({
  ...store.state.blog
});

watch(
  () => store.state.blog,
  (v) => {
    Object.assign(blog, {
      ...v
    });
  }
);

const isNew = computed<boolean>(() => blog.id === -1);
const { loading, setLoading } = useLoading();

const $v = useVuelidate(blogValidations, { blog });
const emit = __emit;

onMounted(() => {
  if (!route.params.id) {
    store.dispatch(Actions.NewBlog);
    Object.assign(blog, { ...store.state.blog });
  }
});

const submit = async () => {
  $v.value.$touch();
  if (!$v.value.$invalid) {
    setLoading(true);
    await store.dispatch(Actions.StoreBlog, blog);

    setLoading(false);
    cancel();
  }
};

const cancel = () => {
  emit("close");
  router.push("/blog");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    blog
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"]),
          class: _normalizeClass({ submitting: _unref(loading) })
        }, [
          _createElementVNode("h2", {
            textContent: _toDisplayString(isNew.value ? 'Add blog' : 'Edit blog')
          }, null, 8, _hoisted_2),
          (isNew.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Fill out the details of the blog"))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "Edit the details of the blog")),
          _createVNode(Field, {
            label: "Title",
            validation: _unref($v).blog.title,
            modelValue: blog.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((blog.title) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(FieldMarkdown, {
            label: "Text",
            validation: _unref($v).blog.text,
            modelValue: blog.text,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((blog.text) = $event)),
            "upload-path": '/api/upload'
          }, null, 8, ["validation", "modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "confirm",
              type: "button",
              disabled: _unref(loading),
              onClick: submit
            }, [
              _hoisted_7,
              _createElementVNode("span", {
                class: "text",
                textContent: _toDisplayString(isNew.value ? 'Add' : 'Edit')
              }, null, 8, _hoisted_8)
            ], 8, _hoisted_6),
            _createElementVNode("button", {
              class: "cancel",
              type: "button",
              onClick: cancel
            }, _hoisted_10),
            (_unref(loading))
              ? (_openBlock(), _createBlock(Loading, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ], 34))
      : _createCommentVNode("", true)
  ]))
}
}

})